import { UPDATE_TIME_SUMMARY_WS, UPDATE_TIME_SUMMARY, SET_USERS } from './chunk-V4FTVBZY.mjs';
import { SELECTED_MODE_INITIAL_STATE } from './chunk-PEXCKIGD.mjs';
import { SET_SELECTED_SETTINGS_MODE_WS, SET_SELECTED_SETTINGS_MODE, SET_REGISTER_TICKET_SETTINGS, SET_REGISTER_SETTINGS, SET_GENERAL_SETTINGS, SET_ROLES, SET_LOCKSCREEN_SETTINGS } from './chunk-DUMQLZJJ.mjs';
import { SET_ROLE_DASHBOARDS, SET_SETTINGS_DASHBOARDS, SET_PRINTER_STATUS_WS } from './chunk-SKLRT3EJ.mjs';
import { __spreadValues } from './chunk-T36PI2YV.mjs';
import { produce } from 'immer';

var settingsSelectedModeReducer = produce((state = SELECTED_MODE_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_LOCKSCREEN_SETTINGS:
      state.currentSettings.lockScreen = action.payload;
      break;
    case SET_ROLES:
      state.currentSettings.roles = action.payload;
      break;
    case SET_USERS:
      if (state.settingsType === "location" /* LOCATION_SETTINGS */)
        state.currentSettings.users = __spreadValues(__spreadValues({}, state.currentSettings.users), action.payload);
      break;
    case SET_GENERAL_SETTINGS:
      state.currentSettings.general = action.payload;
      break;
    case SET_PRINTER_STATUS_WS:
      if ((state.overrideSettingsType || state.currentSettings) === "location" /* LOCATION_SETTINGS */ && state.currentSettings.devices.printers[action.payload.printerId]) {
        state.currentSettings.devices.printers[action.payload.printerId].status = action.payload.status;
        if (action.payload.showInPrinterCenter !== void 0) {
          state.currentSettings.devices.printers[action.payload.printerId].showInPrinterCenter = action.payload.showInPrinterCenter;
        }
      }
      break;
    case SET_REGISTER_SETTINGS:
      state.currentSettings.register = action.payload;
      break;
    case SET_REGISTER_TICKET_SETTINGS:
      state.currentSettings.registerTicket = action.payload;
      break;
    case UPDATE_TIME_SUMMARY:
    case UPDATE_TIME_SUMMARY_WS:
      if (state.id === action.payload.locationId)
        state.currentSettings.users[action.payload.organizationUserId].shiftTimeSummary = action.payload;
      break;
    case SET_SELECTED_SETTINGS_MODE:
    case SET_SELECTED_SETTINGS_MODE_WS:
      return action.payload;
    case SET_SETTINGS_DASHBOARDS:
      state.currentSettings.dashboards = action.payload;
      break;
    case SET_ROLE_DASHBOARDS:
      state.currentSettings.roles[action.payload.roleId].dashboardIds = action.payload.dashboardIds;
      state.currentSettings.roles[action.payload.roleId].defaultDashboardId = action.payload.defaultDashboardId;
      break;
    default:
      return state;
  }
});
var reducers_default = settingsSelectedModeReducer;

export { reducers_default };
